export default __webpack_public_path__ + "static/home-3-hero-bg-dfbf8a94c3d03990cc9c94002c9f8425.jpg";